import React from "react";
import { useTranslate } from "react-admin";
import { useDispatch, useSelector } from "react-redux";
import { changeTheme } from "../administration/actions";
import { AppState } from "../../common/types";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import { IconButton, Tooltip } from "@material-ui/core";

const DarkModeSwitch = () => {
  const translate = useTranslate();
  const dispatch = useDispatch();
  const theme = useSelector((state: AppState) => state.theme);
  let tooltipTitleKey = "userMenu.switchTheme";
  tooltipTitleKey += theme === "dark" ? ".light" : ".dark";

  return (
    <Tooltip title={translate(tooltipTitleKey)}>
      <IconButton
        color="inherit"
        onClick={() =>
          dispatch(changeTheme(theme === "dark" ? "light" : "dark"))
        }
      >
        {theme === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
      </IconButton>
    </Tooltip>
  );
};

export default DarkModeSwitch;
